import { nsPc } from '@qdabra/forms-shared/xmlNamespaces';
import { namespaceCmeData } from '../../formsviewer/constants.namespaces';
import { buildNamespaceManagerFromMap } from '../../utility/xmlHelpers';

const listFormNamespaces = buildNamespaceManagerFromMap({
    my: namespaceCmeData,
    pc: nsPc,
});

export const selectListFormNodes = (start, xpath) =>
    start.selectNodes(xpath, { namespaces: listFormNamespaces });

export const selectListFormNode = (start, xpath) =>
    start.selectSingle(xpath, { namespaces: listFormNamespaces });

export const getListFormNodeValue = (node, xPath) => {
    const selectedNode = selectListFormNode(node, xPath);

    if (!selectedNode) {
        return null;
    }

    return selectedNode.value();
};
